import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('ImportConfigurationSetFactory', ['$http', 'settings', function ($http, settings) {
    return {        
        uploadConfigurationSet: function (configurationSet) {
            return $http.post(settings.ApiURL + settings.ConfigurationSetURL + "/upload", configurationSet);
        },
        importConfigurationSet: function (configurationSet) {
            return $http.post(settings.ApiURL + settings.ConfigurationSetURL + "/import", configurationSet);
        }
    };
}]);

app.controller('ImportConfigurationSetController', ['$scope', '$parse', 'ImportConfigurationSetFactory', '$rootScope', 'settings', 'masterFactory', '$uibModal', 'Upload',
    function ($scope, $parse, ImportConfigurationSetFactory, $rootScope, settings, masterFactory, $uibModal, Upload) {
        $rootScope.pageTitle = "Import TransPac Configuration";
        $scope.compareConfigurationSet = null;
        $scope.importedConfigurationSet = {};
        $scope.importedConfigurationValues = [];
        $scope.dbConfigurationSet = [];        
        $scope.error = "";
        $scope.isFormVisible = false;
        $scope.fileString = null;        
        $scope.file = null;        
        $scope.uploaded = false;
        $scope.imported = false;

        $scope.$watch('files', function (files) {
            $scope.readFile(files, null);
        });

        // Initialization - this runs on load
        var init = function () {
            masterFactory.verifyAuthentication();
        };

        init();

        // Button click functions and submit form function
        $scope.readFile = function (file, errFiles) {            
            $scope.fileString = null;
            $scope.importedConfigurationSet = [];
            $scope.file = null;
            $scope.file = file;
            // code to read the file.  
            if (!IsUndefinedOrNull($scope.file)) {
                var blob = $scope.file.slice(0, $scope.file.size, 'application/json');
                var fr = new FileReader();
                // code to get json string from the file. 
                fr.onload = function (e:any) {
                    $scope.$apply(function () {
                        $scope.fileString = e.target.result;                        
                    });                    
                    $scope.importedConfigurationSet = JSON.parse($scope.fileString);                                        
                };
                fr.readAsText(blob);
            }
            //code to display error when non supported file is selected. 
        }

        $scope.uploadFile = function () {
            $('#loadingModal').modal({ backdrop: 'static' });
            ImportConfigurationSetFactory.uploadConfigurationSet($scope.importedConfigurationSet).success(function (data) {                                
                $scope.compareConfigurationSet = data;
                $scope.uploaded = true;
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'File upload successful.' });
            }).error(function (data, status) {
                $scope.isFormVisible = false;
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        };

        $scope.importConfigurations = function () {            
            // DB version must be same            
            if ($scope.compareConfigurationSet.CurrentDBVersion != $scope.compareConfigurationSet.ImportedDBVersion) {
                $scope.notify.add({ type: 'warning', title: 'Error!', body: 'Cannot Import - Different DB version detected.' });
                return;
            }
            // Imported DB group name required. 
            else if ($scope.compareConfigurationSet.ConfigurationSetType == 'group' &&  $scope.compareConfigurationSet.ImportedDBGroupName == '') {
                $scope.notify.add({ type: 'warning', title: 'Error!', body: 'Cannot Import - Imported Configs Group name required.' });
                return;
            }
            $('#loadingModal').modal({ backdrop: 'static' });
            ImportConfigurationSetFactory.importConfigurationSet($scope.compareConfigurationSet).success(function (data) {
                $scope.imported = true;
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Configurations import successful.' });
            }).error(function (data, status) {
                $scope.isFormVisible = false;
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        };

        $scope.cancelUpload = function () {            
            $scope.fileString = null;            
            $scope.importedConfigurationSet = {};
            $scope.compareConfigurationSet = null;
            $scope.file = null;
            $scope.uploaded = false;
        };

        $scope.cancelImport = function () {
            $scope.cancelUpload();
        };

        $scope.viewComplexConfigValue = function (configurationValue, configTypeToDisplay) {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                templateUrl: 'app-legacy/Entities/templates/complexConfigurationModal_import.html',
                controller: 'ComplexConfigurationModalController',
                controllerAs: 'modalVm',
                size: 'lg',
                scope: $scope,
                resolve: {
                    ComplexConfigurationValue: function () {
                        configurationValue.deviceId = null;
                        configurationValue.driverId = null;
                        if (configTypeToDisplay == 'IMPORTED-DB') {
                            configurationValue.XmlSchema = angular.copy(configurationValue.ImportedDBXmlValue);
                        }
                        else if (configTypeToDisplay == 'CURRENT-DB') {
                            configurationValue.XmlSchema = angular.copy(configurationValue.CurrentDBXmlValue);
                        }
                        return configurationValue;
                    }
                }
            });
        };

        // Helping functions and events
        $scope.closeAlert = function () {
            $scope.error = null;
        };

    }]);

app.controller('ComplexConfigurationModalController', ['$scope', '$uibModalInstance', 'ComplexConfigurationValue', '$filter', '$uibModal',
    function ($scope, $uibModalInstance, ComplexConfigurationValue, $filter, $uibModal) {
        var modalVm = this;
        modalVm.labelConfig = $scope.getLables(ComplexConfigurationValue.Id);
        init();

        modalVm.cancel = function () {
            $uibModalInstance.close('ok');
        };

        modalVm.formSelected = function (index) {
            modalVm.ModalHeading = modalVm.ComplexConfigurationValue.Name;
            modalVm.IsAddNew = false;
            modalVm.MultiFormSettings.selectedFormIndex = index;
        };

        function init() {
            modalVm.ActiveTab = 0;
            modalVm.SortedSelectedList = {};
            modalVm.ComplexConfigurationValue = angular.copy(ComplexConfigurationValue);
            modalVm.ResetComplexConfigurationValue = angular.copy(ComplexConfigurationValue);
            modalVm.ModalHeading = modalVm.ComplexConfigurationValue.Name;
            modalVm.IsSingle = modalVm.ComplexConfigurationValue.XmlSchema.isSingle;
            if (!modalVm.IsSingle) { // multi form settings
                modalVm.MultiFormSettings = {
                    newForm: angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence.splice(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence.length - 1, 1)),
                    stagingComplexConfig: angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence),
                    selectedFormIndex: 0
                };
            }
        };
    }]);
